module.exports = __webpack_public_path__ + "823c1d05c7a52119874c19158f2c4e0d.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/audio/success_beep.mp3
// module id = 385
// module chunks = 1